"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jquery_1 = __importDefault(require("jquery"));
require("@SmartAdminBundle/scss/meeva/libs/_symfony-collection.scss");
/* Usage Example:

```php
$builder->add('foo', CollectionTableType::class, [
    'entry_type'   => ChildType::class,
    'allow_add'    => true,
    'allow_remove' => true,
]);

Oder alternativ manuell:
```php
$builder->add('mycollectionfield', CollectionType::class, [
    'entry_type'   => ChildType::class,
    'allow_add'    => true,
    'allow_remove' => true,
    'attr'         => [
        'class' => 'sf-table-collection',
    ],
]);
```
```html.twig
{% form_theme form with ['@SmartAdmin/Form/smartadmin_horizontal_layout.html.twig', _self] %}
{% block _mycollectionfield_widget %}
    {%- if form is rootform -%}
        {{ form_errors(form) }}
    {%- endif -%}
    <table class="table table-condensed table-bordered" {{ block('widget_container_attributes') }}>
        <!-- Optional -->
        {% set columns = prototype|filter(child => not child.rendered)|length %}
        <thead>
            <tr>
                {% for child in prototype|filter(child => not child.rendered) %}
                    <td>{{ form_label(child) }}</td>
                {% endfor %}
            </tr>
        </thead>
        <!-- End Optional -->

        {%- set attr = attr|merge({
            'data-allow-add': allow_add|default(null),
            'data-allow-delete': allow_delete|default(null),
            'data-prototype': form_row(prototype),
            'data-prototype-name': prototype.vars.name,
            'data-prototype-prefix': prototype.vars.full_name,
            'class': (attr.class|default('') ~ ' collection') | trim
        }) -%}
        <tbody {{ block('attributes') }}>
        {{- block('form_rows') -}}
        </tbody>

        <!-- Optional: Wenn kein Footer und Kein Header existiert, wird automatisch ein leerer Footer angelegt -->
        <tfoot>
            <tr><td colspan="{{ columns }}"></td></tr>
        </tfoot>
        <!-- End Optional -->
    </table>
    {{- form_rest(form) -}}
{% endblock %}
{% block _mycollectionfield_entry_row %}
    <tr>
        {% for child in form|filter(child => not child.rendered) %}
            <td>{{- form_row(child, { label: false }) -}}</td>
        {% endfor %}
    </tr>
{% endblock %}
```

 */
const defaults = {
    selector: {
        collection: "tbody.sf-table-collection"
    },
    eventNamespace: "SymfonyTableCollection",
    table: {
        columnClass: "sf-collection-action"
    },
    buttons: {
        add: {
            selector: ".sf-table-collection-add-item",
            prototype: '<div class="btn btn-success sf-table-collection-add-item"><i class="fa fa-fw fa-plus"></div>'
        },
        remove: {
            selector: ".sf-table-collection-remove-item",
            prototype: '<div class="btn btn-danger sf-table-collection-remove-item"><i class="fa fa-fw fa-trash"></div>'
        },
        sort: {
            selector: ".sf-table-collection-item-sortable-handle",
            prototype: '<div class="btn btn-primary sf-table-collection-item-sortable-handle"><i class="fa fa-fw fa-arrows-alt"></div>'
        }
    }
};
class SymfonyTableCollectionPlugin {
    constructor(app, config) {
        this.app = app;
        this.settings = jquery_1.default.extend(true, {}, defaults, config);
    }
    init() {
        this.refresh(document.body);
    }
    refresh(node) {
        const self = this;
        (0, jquery_1.default)(node).find(this.settings.selector.collection).each(function () {
            const element = (0, jquery_1.default)(this);
            const table = element.closest("table");
            if (element.data("sf-collection")) {
                return;
            }
            element.data("sf-collection", true);
            if (element.data("allow-add")) {
                self.createAddButtons(table);
            }
            if (element.data("allow-delete")) {
                self.createRemoveButtons(element);
            }
            if (element.data("allow-sort")) {
                self.createSortButtons(element);
                self.setupSortable(element);
            }
            self.setupListeners(element);
            element.data("index", element.children().length);
        });
    }
    updateCollectionEntryIndex(collection) {
        const prototypePrefix = collection.data("prototype-prefix").replace(/\[[^\]]+]$/, "");
        const collectionItems = collection.find("> :not(.btn)");
        const prefixExpression = new RegExp(`${prototypePrefix.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&")}\\[\\d+\\]`);
        const updateIndex = (element, index) => {
            const name = (0, jquery_1.default)(element).attr("name");
            if (name) {
                const newName = name.replace(prefixExpression, `${prototypePrefix}[${index}]`);
                (0, jquery_1.default)(element).attr("name", newName);
            }
        };
        collectionItems.each(function (index) {
            (0, jquery_1.default)(this).find("[data-prototype]").each((i, prototypeContainer) => {
                let childPrototype = (0, jquery_1.default)(prototypeContainer).data("prototype");
                let childPrototypePrefix = (0, jquery_1.default)(prototypeContainer).data("prototype-prefix");
                const prototypePrefixExpression = new RegExp(`${prototypePrefix.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&")}\\[\\d+\\]`, "g");
                childPrototype = childPrototype.replace(prototypePrefixExpression, `${prototypePrefix}[${index}]`);
                childPrototypePrefix = childPrototypePrefix.replace(prefixExpression, `${prototypePrefix}[${index}]`);
                (0, jquery_1.default)(prototypeContainer).data("prototype", childPrototype);
                (0, jquery_1.default)(prototypeContainer).data("prototype-prefix", childPrototypePrefix);
            });
            (0, jquery_1.default)(this).find(":input").each((i, element) => updateIndex(element, index));
        });
    }
    setupSortable(element) {
        element.sortable({
            axis: "y",
            items: "> :not(.btn)",
            handle: this.settings.buttons.sort.selector,
            opacity: 0.5
        }).on(`sortupdate.${this.settings.eventNamespace}`, () => {
            // Standard verhalten kann mit $('.sf-collection').off('sortupdate.SymfonyCollection') deaktiviert werden
            this.updateCollectionEntryIndex(element);
        });
    }
    createAddButtons(table) {
        const { columnClass } = this.settings.table;
        const thead = table.find("> thead > tr");
        if (thead.length) {
            let col = thead.children(`.${columnClass}`);
            if (col.length === 0) {
                col = (0, jquery_1.default)("<td></td>").addClass(columnClass).appendTo(thead);
            }
            col.append(this.settings.buttons.add.prototype);
        }
        let tfoot = table.find("> tfoot > tr");
        if (tfoot.length === 0) {
            if (thead.length) {
                // Only create foot, if no head present
                return;
            }
            const prototype = (0, jquery_1.default)(table.children(this.settings.selector.collection).data("prototype"));
            tfoot = (0, jquery_1.default)(`<tfoot><tr><td colspan="${prototype.find(`td:not(${columnClass})`).length}"></td></tr></tfoot>`).appendTo(table).children("tr");
        }
        let col = tfoot.children(`.${columnClass}`);
        if (col.length === 0) {
            col = (0, jquery_1.default)("<td></td>").addClass(columnClass).appendTo(tfoot);
        }
        col.append(this.settings.buttons.add.prototype);
    }
    createRemoveButtons(element) {
        element.children().each((index, row) => {
            if ((0, jquery_1.default)(row).find(this.settings.buttons.remove.selector).length > 0) {
                return;
            }
            const { columnClass } = this.settings.table;
            let col = (0, jquery_1.default)(row).children(`.${columnClass}`);
            if (col.length === 0) {
                col = (0, jquery_1.default)("<td></td>").addClass(columnClass).appendTo(row);
            }
            col.append(this.settings.buttons.remove.prototype);
        });
    }
    createSortButtons(element) {
        element.children().each((index, row) => {
            if ((0, jquery_1.default)(row).find(this.settings.buttons.sort.selector).length > 0) {
                return;
            }
            const { columnClass } = this.settings.table;
            let col = (0, jquery_1.default)(row).children(`.${columnClass}`);
            if (col.length === 0) {
                col = (0, jquery_1.default)("<td></td>").addClass(columnClass).appendTo(row);
            }
            col.append(this.settings.buttons.sort.prototype);
        });
    }
    static removeItem(container, item) {
        const entry = container.children().filter((index, element) => jquery_1.default.contains(element, item));
        (0, jquery_1.default)(entry).remove();
    }
    addItem(container) {
        const itemIndex = container.data("index");
        const prototype = (0, jquery_1.default)(container).data("prototype").replace(new RegExp((0, jquery_1.default)(container).data("prototype-name") || "__name__", "g"), itemIndex);
        container.data("index", itemIndex + 1);
        // if (container.children().length === 0) {
        //   container.after(this.settings.buttons.add.prototype);
        // }
        const newElement = (0, jquery_1.default)(prototype).appendTo(container);
        if (container.data("allow-delete")) {
            this.createRemoveButtons(container);
        }
        if (container.data("allow-sort")) {
            this.createSortButtons(container);
        }
        this.app.partialInit(newElement.get(0));
    }
    setupListeners(element) {
        element.on(`click.${this.settings.eventNamespace}`, this.settings.buttons.remove.selector, (e) => {
            SymfonyTableCollectionPlugin.removeItem(element, e.currentTarget);
        });
        element.parent().on(`click.${this.settings.eventNamespace}`, this.settings.buttons.add.selector, (e) => {
            this.addItem(element);
        });
    }
    destroy() {
        (0, jquery_1.default)(this.settings.selector)
            .off(`click.${this.settings.eventNamespace}`)
            .find(this.settings.buttons.remove.selector).remove()
            .end()
            .siblings(this.settings.buttons.add.selector)
            .remove();
    }
}
exports.default = SymfonyTableCollectionPlugin;
